import { render, staticRenderFns } from "./PNCounselors.vue?vue&type=template&id=ac19e12c"
import script from "./PNCounselors.vue?vue&type=script&lang=js"
export * from "./PNCounselors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports